import { IconButton, PrimaryButton, SecondaryButton } from "../aat/components/UI/Button/Button";
import Icon from "../aat/components/Icon/Icon";
import * as React from "react";
import Anchor from "../components/Router/Anchor";
import { BUTTON_TYPE, Link } from "../typings/typings";

export const renderButton = (style: BUTTON_TYPE | undefined, link: Link, index?: number) =>
{
    const url = link.route?.path || link.url || "";
    const label = link.title || link.name || "";
    if (link)
    {
        switch (style?.toLowerCase())
        {
            case "plus":
                return <IconButton key={`lbk_${index}`} as={Anchor} to={url} target={link.target}>
                    <Icon name="plus" className="w-5 h-5 md:w-7 md:h-7 pointer-events-none fill-current" />
                </IconButton>;
            case "secondary":
                return <SecondaryButton key={`lbk_${index}`} as={Anchor} to={url} target={link.target} >
                    {label}
                </SecondaryButton>;
            default:
                return <PrimaryButton key={`lbk_${index}`} as={Anchor} to={url} target={link.target}>
                    {label}
                </PrimaryButton>;
        }
    }
};